export default "__VITE_ASSET__CUFjFUQI__"